import {Input} from '@/components/ui/input';
import {Eye, EyeOff} from 'lucide-react';
import React, {useState} from 'react';

const PasswordInput = React.forwardRef<
  HTMLInputElement,
  React.ComponentPropsWithoutRef<typeof Input>
>(({...props}, ref) => {
  const [showPassword, setShowPassword] = useState(false);

  function handleShowPasswordToggle() {
    setShowPassword((prev) => !prev);
  }

  return (
    <div className="relative">
      <Input ref={ref} type={showPassword ? 'text' : 'password'} {...props} />
      <button
        type="button"
        onClick={handleShowPasswordToggle}
        className="absolute inset-y-0 right-0 flex items-center pr-3 text-sm leading-5"
      >
        {showPassword ? <Eye size={20} /> : <EyeOff size={20} />}
        <span className="sr-only">{showPassword ? 'Hide password' : 'Show password'}</span>
      </button>
    </div>
  );
});

PasswordInput.displayName = 'PasswordInput';

export default PasswordInput;
